import { render, staticRenderFns } from "./ProviderStreamsComparator.vue?vue&type=template&id=156dcb8d&scoped=true"
import script from "./ProviderStreamsComparator.vue?vue&type=script&lang=ts"
export * from "./ProviderStreamsComparator.vue?vue&type=script&lang=ts"
import style0 from "./ProviderStreamsComparator.vue?vue&type=style&index=0&id=156dcb8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156dcb8d",
  null
  
)

export default component.exports